import { createAction } from "../../utils";
import { SET_INPUT_DIRTY } from "../../constants";

const inputDirty = createAction(SET_INPUT_DIRTY);

export const setInputDirty = () => (dispatch) => {
  dispatch(inputDirty());
};
